import en from '../localization/en.json';
import de from '../localization/de.json';
import fr from '../localization/fr.json';
import es from "../localization/es.json"
import React, { createContext, useContext, useState } from 'react';

type TranslationType = { [key: string]: string };
type TranslationsFunction = (text: string) => string;

const enTranslations = en as TranslationType;
const deTranslations = de as TranslationType;
const frTranslations = fr as TranslationType;
const spTranslations = es as TranslationType;

interface TranslationContextType {
  translations: TranslationsFunction;
  currentLang: string;
  setAppLanguage: (lang: string) => void;
}

const TranslationContext = createContext<TranslationContextType>({
  translations: () => '',
  currentLang: 'en',
  setAppLanguage: () => { },
});

export const useTranslation = () => useContext(TranslationContext);

export const TranslationProvider = ({ children }: { children: React.ReactNode }) => {
  const [currentLang, setCurrentLang] = useState<string>(localStorage.getItem('lang') || 'en');

  const setAppLanguage = (lang: string) => {
    localStorage.setItem('lang', lang);
    setCurrentLang(lang);
  };

  // const translations: TranslationsFunction = (text) => {
  //   return enTranslations[text] === undefined && deTranslations[text] === undefined
  //     ? text
  //     : currentLang === 'en' || deTranslations[text] === undefined
  //       ? enTranslations[text]
  //       : deTranslations[text];
  // };
  const translations: TranslationsFunction = (text) => {
    if (
      enTranslations[text] === undefined &&
      deTranslations[text] === undefined &&
      frTranslations[text] === undefined
    ) {
      return text;
    }

    if (currentLang === 'de') {
      return deTranslations[text] ?? enTranslations[text] ?? text;
    }

    if (currentLang === 'fr') {
      return frTranslations[text] ?? enTranslations[text] ?? text;
    }

    if (currentLang === 'es') {
      return spTranslations[text] ?? enTranslations[text] ?? text;

    }

    return enTranslations[text] ?? text;
  };


  return (
    <TranslationContext.Provider value={{ translations, currentLang, setAppLanguage }}>
      {children}
    </TranslationContext.Provider>
  );
};
